import { useCallback, useEffect, useState } from "react";

import { SubscriptionTier } from "@repo/ui/pricing-hooks";
import { useRemoteConfig } from "@shapr3d/frontend-lib";

import { CancellationSurveyModal } from "../CancellationSurveyModal/CancellationSurveyModal";
import { SubscriptionCancelModal } from "../SubscriptionCancelModal/SubscriptionCancelModal";

export const CancellationFlow: React.FC<{
  open: boolean;
  onClose: () => void;
  onCancelSubscription: () => void;
  isLoading: boolean;
  editorSeatCount: number;
  isSubscriptionInGracePeriod: boolean;
  subscriptionExpirationDate: string;
  subscriptionTier: SubscriptionTier;
}> = ({
  open,
  onClose,
  onCancelSubscription,
  isLoading,
  editorSeatCount,
  isSubscriptionInGracePeriod,
  subscriptionExpirationDate,
  subscriptionTier,
}) => {
  const cancellationSurveyFlag = useRemoteConfig("web_cancellation_survey-cd");
  const isFlagLoading = cancellationSurveyFlag === undefined;
  const isTreatment = cancellationSurveyFlag === "treatment";

  const [step, setStep] = useState<"confirm" | "survey">("confirm");

  useEffect(() => {
    if (open) setStep("confirm");
  }, [open]);

  const handleClose = useCallback(() => {
    setStep("confirm");
    onClose();
  }, [onClose]);

  if (isTreatment && step === "survey") {
    return (
      <CancellationSurveyModal
        open={open}
        onClose={handleClose}
        onCancelSubscription={onCancelSubscription}
        isLoading={isLoading}
        subscriptionTier={subscriptionTier}
        subscriptionExpirationDate={subscriptionExpirationDate}
      />
    );
  }

  return (
    <SubscriptionCancelModal
      open={open}
      onClose={handleClose}
      isLoading={isLoading || isFlagLoading}
      editorSeatCount={editorSeatCount}
      isSubscriptionInGracePeriod={isSubscriptionInGracePeriod}
      subscriptionExpirationDate={subscriptionExpirationDate}
      subscriptionTier={subscriptionTier}
      mode={isTreatment ? "survey" : "cancel"}
      onCTA={isTreatment ? () => setStep("survey") : onCancelSubscription}
    />
  );
};
